import React, { useEffect } from 'react'

import { Drawer, DrawerAction, DrawerActions } from '@acorns/web-components'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'

import { disclosureView } from '../segment'
import { StyledDisclosureContent } from './DrawerComponents'

export type Props = {
  showDisclosureDrawer: boolean
  closeDisclosureDrawer: () => void
  disclosureDrawerBackButtonPress?: () => void
  goToPinwheel: () => void
  isLoadingDDLinkData: boolean
}

export const DisclosureDrawer: React.FC<Props> = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const analytics = useAnalyticsClient()

  const draweractions: DrawerAction[] = [
    {
      label: getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.cta.primary',
      }),
      handler: props.goToPinwheel,
      testId: 'done_button',
      disabled: props.isLoadingDDLinkData,
    },
  ]
  if (props.disclosureDrawerBackButtonPress) {
    draweractions.unshift({
      label: getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.cta.secondary',
      }),
      handler: props.disclosureDrawerBackButtonPress,
      testId: 'disclosure_back_button',
      secondary: true,
    })
  }

  useEffect(() => {
    if (props.showDisclosureDrawer) {
      analytics.track('Screen Viewed', disclosureView())
    }
  }, [props.showDisclosureDrawer])

  return (
    <Drawer
      isOpen={props.showDisclosureDrawer}
      onClose={props.closeDisclosureDrawer}
      title={getRemoteString({
        key: 'spend.direct_deposit.drawer.terms.title',
      })}
    >
      <StyledDisclosureContent>
        {getRemoteString({
          key: 'spend.direct_deposit.drawer.terms.body.pinwheel',
        })}
      </StyledDisclosureContent>
      <DrawerActions actions={draweractions} />
    </Drawer>
  )
}
